import { h } from '@stencil/core';
import { isBrowser } from '../../../../globals/utils';
import { http } from '../../../../globals/http';
export class ComparisonBarWrapper {
  constructor() {
    this.breakpointListener = () => {
      if (isBrowser()) {
        this.isMobile = !this.mql.matches;
      }
    };
    this.configUrl = undefined;
    this.config = undefined;
    this.isPublic = 'false';
    this.isMobile = undefined;
  }
  async fetchComparisonBarConfigs() {
    try {
      if (!this.config) {
        this.config = await http.get(this.configUrl);
      }
    }
    catch (error) {
      console.error(error);
    }
  }
  setupResizeListeners() {
    if (isBrowser()) {
      this.mql = window.matchMedia('(min-width: 980px)');
      this.isMobile = !this.mql.matches;
      this.mql.addListener(this.breakpointListener);
    }
  }
  componentDidLoad() {
    if (window.isAsco)
      return;
    this.fetchComparisonBarConfigs();
    this.setupResizeListeners();
  }
  disconnectedCallback() {
    if (!isBrowser() || window.isAsco)
      return;
    this.mql.removeListener(this.breakpointListener);
  }
  render() {
    var _a, _b, _c, _d;
    if (window.isAsco)
      return null;
    return (h("pes-comparison-bar", { localeCode: (_a = this.config) === null || _a === void 0 ? void 0 : _a.localeCode, compareCta: (_b = this.config) === null || _b === void 0 ? void 0 : _b.labels.compareCta, clearListLabel: (_c = this.config) === null || _c === void 0 ? void 0 : _c.labels.clearList, compareLabel: (_d = this.config) === null || _d === void 0 ? void 0 : _d.labels.compareLabel, isConfigured: Boolean(this.config), isMobile: this.isMobile, isPublic: this.isPublic === 'true' }));
  }
  static get is() { return "pes-comparison-bar-wrapper"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["comparison-bar-wrapper.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["comparison-bar-wrapper.css"]
    };
  }
  static get properties() {
    return {
      "configUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "config-url",
        "reflect": false
      },
      "config": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TComparisonBarConfig",
          "resolved": "{ labels: { compareLabel: string; clearList: string; compareCta: string; }; localeCode: string; isPublic?: boolean; }",
          "references": {
            "TComparisonBarConfig": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isPublic": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-public",
        "reflect": false,
        "defaultValue": "'false'"
      }
    };
  }
  static get states() {
    return {
      "isMobile": {}
    };
  }
}
